module.exports = __webpack_public_path__ + "img/IIndianHero64_ua.3a11e9c7.webp";